import { useState } from 'react'

import { AssessmentComponentsTable } from './AssessmentComponentsTable'
import { AssessmentSourcesTable } from './AssessmentSourcesTable'
import { ProjectTeamGrid } from './ProjectTeamGrid'
import { TheApproachPanels } from './TheApproachPanels'

const TABS = ['Assessment Components', 'Assessment Sources', 'The Approach', 'Project Team'] as const

type Tab = (typeof TABS)[number]

export const AssessmentTabs = () => {
  const [activeTab, setActiveTab] = useState<Tab>('Assessment Components')

  return (
    <div className="w-full assessment-page-container">
      <div className="assessment-tabs">
        {TABS.map(tab => (
          <button
            key={tab}
            className={`assessment-tab subtitle-m ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="w-full mt-10">
        {activeTab === 'Assessment Components' && <AssessmentComponentsTable />}
        {activeTab === 'Assessment Sources' && <AssessmentSourcesTable />}
        {activeTab === 'The Approach' && <TheApproachPanels />}
        {activeTab === 'Project Team' && <ProjectTeamGrid />}
      </div>
    </div>
  )
}
